import Config from "../../../../../../shared/src/ranj/app/config/Config";

export default class GameConfig extends Config {

    constructor() {
        super();
    }
    
    /**
     * 
     * @returns {Object.<string, {description: string, castMovieClip: string}>}
     */
    getCast() {
        return this.getValue("cast");
    }
}